import { render } from "./CouncilMembers.vue?vue&type=template&id=75422c8c&scoped=true"
import script from "./CouncilMembers.vue?vue&type=script&lang=js"
export * from "./CouncilMembers.vue?vue&type=script&lang=js"

import "./CouncilMembers.vue?vue&type=style&index=0&id=75422c8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75422c8c"]])

export default __exports__